import { useState, useEffect } from "react";
import { api } from "../api";

export default function HistoryView() {
  const [signals, setSignals] = useState([]);
  const [days, setDays]       = useState(30);

  useEffect(() => {
    api.getHistory(days).then(setSignals);
  }, [days]);

  const buys = signals.filter(s => s.trend_signal === "BUY");
  const withSims = buys.filter(s => s.simulations?.length > 0);
  const winRate = (window) => {
    const wins = withSims.filter(s => {
      const sim = s.simulations?.find(x => x.window === window);
      return sim && sim.pnl_pct > 0;
    });
    return withSims.length > 0 ? Math.round((wins.length / withSims.length) * 100) : null;
  };

  const exportCSV = () => {
    const rows = [
      ["Symbol","Name","Chain","Score","Signal","Detected","Price"],
      ...signals.map(s => [
        s.symbol, s.name, s.chain, s.security_score, s.trend_signal,
        s.detected_at?.slice(0,10), s.price_at_detection,
      ]),
    ];
    const csv = rows.map(r => r.join(",")).join("\n");
    const a = document.createElement("a");
    a.href = "data:text/csv," + encodeURIComponent(csv);
    a.download = `cryptoscan-history-${days}j.csv`;
    a.click();
  };

  const TH = { padding:"8px 12px", fontSize:8, color:"#2A3040", letterSpacing:2,
               borderBottom:"1px solid #1C2030", textAlign:"left", textTransform:"uppercase" };
  const TD = { padding:"9px 12px", borderBottom:"1px solid #111520", fontSize:11 };

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:14, animation:"fadeIn .3s ease" }}>
      {/* Stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:10 }}>
        {[
          ["Signaux total",  signals.length],
          ["Signaux BUY",    buys.length],
          ["Win rate 1j",    winRate("1j") !== null ? `${winRate("1j")}%` : "—"],
          ["Win rate 7j",    winRate("7j") !== null ? `${winRate("7j")}%` : "—"],
        ].map(([label, val]) => (
          <div key={label} style={{ background:"#0D1117", border:"1px solid #1C2030",
            borderRadius:8, padding:"14px 16px" }}>
            <div style={{ fontSize:8, color:"#2A3040", letterSpacing:2, marginBottom:6 }}>{label}</div>
            <div style={{ fontSize:22, fontWeight:700, color:"#00E5C0", fontFamily:"IBM Plex Mono" }}>{val}</div>
          </div>
        ))}
      </div>

      {/* Controls */}
      <div style={{ display:"flex", gap:8, alignItems:"center" }}>
        {[7, 14, 30].map(d => (
          <button key={d} onClick={() => setDays(d)} style={{
            background: days===d ? "#00E5C033":"transparent",
            color: days===d ? "#00E5C0":"#555E6E",
            border:`1px solid ${days===d?"#00E5C044":"#1C2030"}`,
            borderRadius:6, padding:"5px 12px", fontSize:9,
            fontFamily:"IBM Plex Mono", cursor:"pointer",
          }}>
            {d}j
          </button>
        ))}
        <button onClick={exportCSV} style={{
          marginLeft:"auto", background:"transparent", color:"#555E6E",
          border:"1px solid #1C2030", borderRadius:6, padding:"5px 12px",
          fontSize:9, fontFamily:"IBM Plex Mono", cursor:"pointer",
        }}>
          ↓ Export CSV
        </button>
      </div>

      {/* Table */}
      <div style={{ background:"#0D1117", border:"1px solid #1C2030",
                    borderRadius:10, overflow:"hidden" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ background:"#0A0C10" }}>
              {["Token","Chain","Score","Signal","Date détection","Prix détection"].map(h => (
                <th key={h} style={TH}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {signals.map(sig => (
              <tr key={sig._id}>
                <td style={TD}>
                  <span style={{ fontWeight:700, color:"#E0E4F0" }}>{sig.symbol}</span>
                  <span style={{ color:"#2A3040", fontSize:9, marginLeft:6 }}>{sig.name}</span>
                </td>
                <td style={TD}><span style={{ color:"#555E6E" }}>{sig.chain}</span></td>
                <td style={TD}>
                  <span style={{ color: sig.security_score >= 70 ? "#00E5C0" : sig.security_score >= 45 ? "#F59E0B" : "#E03030", fontWeight:700 }}>
                    {sig.security_score}
                  </span>
                </td>
                <td style={TD}>
                  <span style={{ color: sig.trend_signal==="BUY" ? "#00E5C0":"#2A3040" }}>
                    {sig.trend_signal === "BUY" ? "▲ BUY" : "— HOLD"}
                  </span>
                </td>
                <td style={TD}><span style={{ color:"#555E6E" }}>{sig.detected_at?.slice(0,10)}</span></td>
                <td style={TD}>
                  <span style={{ fontFamily:"IBM Plex Mono", color:"#8892A4" }}>
                    ${sig.price_at_detection?.toLocaleString(undefined,{maximumFractionDigits:4}) ?? "—"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
